import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext'
import StartProcess from './StartProcess'
import Card from '../ui-elements/Card'

function ProcessComplete() {
    const { processId } = useParams()
    const { processData, t } = useContext(GlobalContext)

    const thisProcessData = processId && processData && processData[processId]
    const processName = thisProcessData && thisProcessData.DisplayName

    return (
        <div className={`w-full flex-1 h-full flex flex-col items-center`}>
            <div className={`max-w-3xl w-full px-5 py-10 flex flex-col gap-6 items-center`}>
                <Card>
                    <div className={`w-full flex flex-col gap-6 items-center text-center py-4`}>
                        <div className={`text-5xl`}>✅</div>
                        <h2 className={`text-3xl font-righteous text-brandblue`}>
                            {t('ProcessPages.ProcessComplete.heading')}
                        </h2>
                        {processName && (
                            <p className={`text-lg text-gray-600`}>{processName}</p>
                        )}
                        {thisProcessData && processId && (
                            <StartProcess
                                thisProcessData={thisProcessData}
                                processId={processId}
                            />
                        )}
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default ProcessComplete
